import "../../sass/pages/userZone.scss";

import Swiper, { Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";

window.drupalSettings.user.uid <= 0 && location.replace('/iniciar-sesion')

window.addEventListener("load", () => {
  window.dataLayer = window.dataLayer || [];
  eventSlider();
  menuUserFixed()
  getDataLogin()
});

function getDataLogin() {
  const datalayer = sessionStorage.getItem("dataLogin")
  if (datalayer) {
    window.dataLayer.push(JSON.parse(datalayer))

    
    sessionStorage.removeItem("dataLogin")
  }
}

const menuUserFixed = () => {
  const menuUser = document.querySelector('.userMenu') as HTMLElement
  menuUser.classList.add('zona-usuario')
}

const eventSlider = () => {
  const swiper = new Swiper(".st_user--slider", {
    modules: [Pagination],
    slidesPerView: 1.2,
    spaceBetween: 25,
    pagination: {
      el: ".st_user--slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      440: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
};
